var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"id":_vm.id,"centered":false,"modal-class":['base-sheet', `base-sheet-${_vm.width}`],"scrollable":""},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(scope){return [_vm._t(name,null,null,scope)]}}})],null,true)},'base-modal',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }